export default "__VITE_ASSET__Bc6BrDqQ__"